var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPasskeyManage22({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    stroke: "#3362FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 9.16667V14.1667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 10.8333H18.3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 17.5V15.8333C2.5 14.9493 2.85119 14.1014 3.47631 13.4763C4.10143 12.8512 4.94928 12.5 5.83333 12.5H10.8333C11.4421 12.4999 12.0392 12.6665 12.56 12.9817"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 9.16667C10.1743 9.16667 11.6667 7.67428 11.6667 5.83333C11.6667 3.99238 10.1743 2.5 8.33333 2.5C6.49238 2.5 5 3.99238 5 5.83333C5 7.67428 6.49238 9.16667 8.33333 9.16667Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 17.5C17.5871 17.5 18.3333 16.7538 18.3333 15.8333C18.3333 14.9129 17.5871 14.1667 16.6667 14.1667C15.7462 14.1667 15 14.9129 15 15.8333C15 16.7538 15.7462 17.5 16.6667 17.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPasskeyManage22);
export default __webpack_public_path__ + "static/media/icon-passkey-manage-22.897dfcd2af0d107c9fb99b44c2a2e656.svg";
export { ForwardRef as ReactComponent };